"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/Participant.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');
var _Participant = require('web/components/VideoCall/OnCall/ParticipantsBoard/Participant'); var _Participant2 = _interopRequireDefault(_Participant);
















// Was a class inside connect(): memo keeps connect's shallow props bail-out,
// so a tile re-renders only when its own props or its room user's problem
// code change (its media elements are never re-attached by the board).
const ParticipantContainer = ({
  roomKey, roomUserKey, participantKey, onPick,
  audioTrack, videoTrack,
  isScreenParticipant,
  name, isMe, isActive,
  isLoading,
}) => {
  const problemCode = _hooks.useAppSelector.call(void 0, state =>
    // SAFETY: an undefined key looks up `users[undefined]` (no user), as the
    // JS did.
    (_videoRoom.selectVideoRoomUser.call(void 0, roomUserKey , roomKey, state) || {}).ProblemCode,
  )

  const handlePick = _react.useCallback.call(void 0, () => onPick(participantKey), [onPick, participantKey])

  return (
    _react2.default.createElement(_Participant2.default, {
      audioTrack: audioTrack,
      videoTrack: videoTrack,
      isScreenParticipant: isScreenParticipant,
      isActive: isActive,
      // SAFETY: every board participant has a name (OnCall sets one).
      name: name ,
      isMe: isMe,
      isLoading: isLoading,
      onParticipantPick: handlePick,
      // SAFETY: null (no problem reported) is passed through as before; the
      // tile treats it like undefined.
      problemCode: problemCode , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
    )
  )
}

exports. default = _react.memo.call(void 0, ParticipantContainer)
